import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　選定済一覧を出力するサービス
 *
 * @export OutputSelectedListService
 * @class OutputSelectedListService
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class OutputSelectedListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof OutputSelectedListService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof CheckRegistPlanService
   */
  private vo: {
    dispMode: '',
    orderCode: '',
    mediumType: '',
    sellAreaCode: '',
    orderNumQuotaCode: '',
    coopCode: '',
    classCode: '',
    middleClassCode: '',
    smallClassCode: '',
    pageNo: '',
    buyerCode: '',
    displayItemSetDiv: '',
    orderClientCode: '',
    orderClientKanji: '',
    payeeClientCode: '',
    payeeClientKanji: '',
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof OutputSelectedListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputSelectedListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DispMode: this.vo.dispMode,
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        SellAreaCode: this.vo.sellAreaCode,
        OrderNumQuotaCode: this.vo.orderNumQuotaCode,
        CoopCode: this.vo.coopCode,
        ClassCode: this.vo.classCode,
        MiddleClassCode: this.vo.middleClassCode,
        SmallClassCode: this.vo.smallClassCode,
        PageNo: this.vo.pageNo,
        BuyerCode: this.vo.buyerCode,
        DisplayItemSetDiv: this.vo.displayItemSetDiv,
        OrdrClientCode: this.vo.orderClientCode,
        OrdrClientKanji: this.vo.orderClientKanji,
        PayeeClientCode: this.vo.payeeClientCode,
        PayeeClientKanji: this.vo.payeeClientKanji
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof OutputSelectedListService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputSelectedList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputSelectedListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
